import { Component, OnInit } from '@angular/core';
import {SpecialitesService} from '../../services/specialites/specialites.service';

@Component({
  selector: 'app-sidebar-specialites',
  templateUrl: './sidebar-specialites.component.html',
  styleUrls: ['./sidebar-specialites.component.scss']
})
export class SidebarSpecialitesComponent implements OnInit {

    specialites: any;

    constructor(
        private specialitesService: SpecialitesService
    ) { }

    ngOnInit(): void {
        const t = this;
        t.loadItems();
    }

    loadItems() {
        const t = this;
        this.specialitesService.get().subscribe((data: any) => {
            t.specialites = data;
        });
    }

}
